import { RemoteActualIssueProductsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const actualIssueProductsService = new RemoteActualIssueProductsService(httpClient)
